/**
 * Dziennik aktywności kont firmowych (backend `accounts.ZdarzenieFirmy`, decyzja właściciela 2026-10-13).
 *
 * Większość zdarzeń zapisuje sam serwer (klienci, terminy, zestawy, zespół). Tu tylko to, czego serwer nie widzi,
 * bo dzieje się w przeglądarce: pobranie PDF oferty, model i moduły w Projekcie 3D, wynik asystenta, pobrane
 * dokumenty, pierwsza zmiana w formularzu OSD, PSP albo teczki PME2 (`narzedzie_rozpoczete`, hak
 * `hooks/useRozpoczecieNarzedzia`). Wysyłamy WYŁĄCZNIE dla zalogowanego konta firmowego (flagę ustawia
 * `AuthContext`), bez czekania na odpowiedź i bez błędów: dziennik nie może spowolnić ani zepsuć strony.
 *
 * Nazwy i klucze szczegółów to lista zamknięta po stronie serwera (`aktywnosc.Z_PRZEGLADARKI`): nowa nazwa
 * wymaga wpisu tam, inaczej serwer ją pominie. Nigdy nie wysyłaj niczego o kliencie firmy: ani danych osobowych,
 * ani parametrów jego instalacji (moc, pojemność, kwota, województwo). Dziennik opisuje działania osób z firmy,
 * a dane klientów firma nam powierza (decyzja właściciela 2026-10-13). Wolno: nazwę zdarzenia i kategorie
 * niezależne od klienta, np. `rodzaj` modelu (dach, grunt), `wynik` asystenta, `dokument`, `wariant`, `narzedzie`.
 *
 * To NIE jest anonimowy pomiar ruchu (`lib/pomiar.js`): tamten nie wie, kto klika, i tak ma zostać.
 */
import { apiFetch } from '../api/apiFetch'
import { zdarzenie } from './pomiar'

const ADRES = `${process.env.REACT_APP_ACCOUNT_API_URL || '/api/v1/account'}/aktywnosc`

let kontoFirmowe = false

/** Wołane przez `AuthContext` po każdej zmianie profilu (zalogowanie, wylogowanie, zmiana rodzaju konta). */
export const ustawKontoFirmowe = (tak) => { kontoFirmowe = Boolean(tak) }

export const czyKontoFirmowe = () => kontoFirmowe

const csrf = () => {
  const m = document.cookie.match(/(^|;\s*)csrftoken=([^;]*)/)
  return m ? decodeURIComponent(m[2]) : null
}

/** Jedno zdarzenie: `nazwa` z listy serwera, `szczegoly` małe i bez danych klientów firm (tylko kategorie). */
export const aktywnosc = (nazwa, szczegoly = {}) => {
  if (!kontoFirmowe) return
  try {
    const headers = { 'Content-Type': 'application/json' }
    const token = csrf()
    if (token) headers['X-CSRFToken'] = token
    apiFetch(ADRES, {
      method: 'POST',
      headers,
      credentials: 'same-origin',
      // Przeżywa przejście na inną stronę (np. powrót do asystenta zaraz po kliknięciu).
      keepalive: true,
      body: JSON.stringify({ n: nazwa, d: szczegoly }),
    }).catch(() => {})
  } catch {
    // dziennik nigdy nie przerywa działania strony
  }
}

/**
 * Pobrany dokument PDF (zgłoszenie do OSD, zawiadomienie i plan do PSP, protokół PME2): anonimowo w pomiarze
 * ruchu dla każdego i w dzienniku firmy dla konta firmowego. `dokument`: krótki identyfikator, np. `osd`.
 */
export const pobranyDokument = (dokument) => {
  zdarzenie('dokument_pdf', dokument)
  aktywnosc('dokument_pdf', { dokument })
}
